import { render, staticRenderFns } from "./ModalDiaAgenda.vue?vue&type=template&id=70a497e2&"
import script from "./ModalDiaAgenda.vue?vue&type=script&lang=js&"
export * from "./ModalDiaAgenda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports